// extracted by mini-css-extract-plugin
export default {"container":"InfoWidget_container__8Igr-"};